export default "__VITE_ASSET__C51au5Ya__"